<!-- Start: Rejwan: 09-02-2026 Front Routes -->
<template>
    <div>
    <div>
    <b-overlay rounded="sm" class="b-overlay-loan-breakdown" :show="showoverlaymodal_loan_breakdown">
        <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>
        <b-alert show dismissible fade v-if='warningmsg' variant='warning'>{{warningmsg}}</b-alert>
        <b-alert show dismissible fade v-if='dangermsg' variant='danger'>{{dangermsg}}</b-alert>
        
        <div  class="clearfix row no-gutters" v-if="employee_id>0">            
            <!-- <loan-public-info :pageurl="this.$api_url"  :employee_id="employee_id" :key="c_flg"></loan-public-info> --> <!-- Start: Rejwan: 22-02-2026 Front Routes -->
        </div>
        <div class="row  py-3">
            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-6 py-3">
                <div class="card dash-widget">
                <div class="card-body">
                <div class="dash-widget-info">
                    <div class="title">Total Advance Amount</div>
               
                    <div class="amount">
                    <span class="dash-widget-icon" style="height: 55px; width: 35px;">&nbsp;&#2547&nbsp;</span> <span class="dash-widget-val"> {{formatMoney(loan.loan_amount)}}</span> 
                     </div>
                </div>
                </div>
                </div>
            </div>

            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-6 py-3">
                <div class="card dash-widget">
                <div class="card-body">
                <div class="dash-widget-info">
                    <div class="title">Total Service Charge Amount</div>

                    <div class="amount">
                        <span class="dash-widget-icon" style="height: 55px; width: 35px;">&nbsp;&#2547&nbsp;  </span> <span class="dash-widget-val">{{formatMoney(loan.interest_amount)}}</span> 

                     </div>
                  
                </div>
                </div>
                </div>
            </div>

            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-6 py-3">
                <div class="card dash-widget">
                <div class="card-body">
                <div class="dash-widget-info">
                    <div class="title">Paid Amount</div>
                <div class="amount">
                    <span class="dash-widget-icon" style="height: 55px; width: 35px;">&nbsp;&#2547&nbsp; </span> <span class="dash-widget-val"> {{formatMoney(loan_breakdown.debit_amount)}}</span> 
                </div>
                    
                </div>
                </div>
                </div>
            </div>

            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-6 py-3">
                <div class="card dash-widget">
                <div class="card-body">
                
                <div class="dash-widget-info">
                
                <div class="title">Remaining Amount</div>
                <div class="amount">
                    <span class="dash-widget-icon" style="height: 55px; width: 35px;">&nbsp;&#2547&nbsp; </span> <span class="dash-widget-val"> {{formatMoney(loan_breakdown.remaining_amount)}}</span>

                </div>
                
                </div>
                </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-6 py-3">
                <div class="card dash-widget">
                <div class="card-body">
                
                <div class="dash-widget-info">
                
                <div class="title">Transactions</div>
                <div class="amount">
                    <span class="dash-widget-icon" style="height: 55px; width: 35px;">&nbsp;#&nbsp; </span> <span class="dash-widget-val">  {{loan_breakdown.debit_month}} / {{loan.loan_tenure}}</span>

                </div>
               
                </div>
                </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-6 py-3">
                <div class="card dash-widget">
                <div class="card-body">
                
                <div class="dash-widget-info">
               
                <div class="title">Service Charge Transactions</div> 
                <div class="amount">
                    <span class="dash-widget-icon" style="height: 55px; width: 35px;">&nbsp;#&nbsp; </span> <span class="dash-widget-val"> {{loan_breakdown.interest_month}} / {{loan.interest_tenure}}</span>
                </div>
                
                </div>
                </div>
                </div>
            </div>
        </div>
       
        <!-- Start: Rejwan: 10-02-2026(1) Front Routes -->
     <!-- <template active  >
    
        <b-overlay rounded="sm">
           <div v-if="transactions.length > 0" class=" p-3">                    
                <div class="row table-head">
                                 
                    <div class="col-sm-4 font-weight-bold py-2">
                        PF Slip Name
                    </div>
                    <div class="col-sm-3 font-weight-bold py-2">
                        Download PF Slip
                    </div>
                    <div class="col-sm-2 font-weight-bold py-2">
                        Amount
                    </div>
                    <div class="col-sm-1 font-weight-bold py-2">
                        Type
                    </div>
                    <div class="col-sm-2 font-weight-bold py-2">
                        Month
                    </div>
                </div>
            
                <div class="row table-row hover-bg" v-for="transaction in transactions" :key="transaction.id">
                   
                    <div class="col-sm-4 py-2 align-items-center d-flex" v-if="transaction.payslip_id >0">
                        <div class=""> {{replacePayrun(pay_slips[transaction.payslip_id].pay_slip_name)}}</div>
                    </div>
                    <div class="col-sm-4 py-2 align-items-center d-flex" v-if="transaction.payslip_id ==0">
                         <div class="">N/A</div>
                    </div>
                    <div class="col-sm-3 py-2 align-items-center d-flex" v-if="transaction.payslip_id > 0">
                         <b-button class="border rounded bg-light float-right py-1 px-2"  type="submit" variant="primary" @click="downloadPaySlip(transaction.payslip_id,pay_slips[transaction.payslip_id].fiscal_year)"><i class="far fa-file-pdf px-1" aria-hidden="true" style="font-size:16px;color:red"></i> Download PDF</b-button>
                    </div>
                    <div class="col-sm-3 py-2 align-items-center d-flex" v-if="transaction.payslip_id ==0">
                         <div class="">N/A</div>
                    </div>
                    <div class="col-sm-2 py-2 align-items-center d-flex">
                        {{formatMoney(transaction.amount)}} 
                    </div>
                    <div class="col-sm-1 py-2 align-items-center d-flex">
                        {{tx_type[transaction.tx_type]}} 
                    </div>
                     <div class="col-sm-2 py-1 align-items-center d-flex">
                        {{transaction.month}} 
                    </div>
                
                </div>                        
            </div>
            <div v-else class=" p-4">  
                Sorry no transaction to show.
            </div>
             
            
        </b-overlay> 

        </template>   -->
        <!-- End: Rejwan: 10-02-2026(1) Front Routes -->
    </b-overlay>
    </div>
    </div>
    
</template>
<script>

    

    
    export default{

        mounted() {
            //this.showoverlay = false;  
            setTimeout(this.showContent , 3000);    
            
        },
        // props: ['pageurl' ,'readonly','loan_id','employee_id'], // Start: Rejwan: 22-02-2026 Front Routes
        props: ['pageurl' ,'readonly','loan_id','employee_id', 'is_self'], // Start: Rejwan: 22-02-2026 Front Routes
        
        data(){            
            
            return {
                styleA: 'color:#55ce63 !important',
                styleB: 'color:#212529 !important',
                installments:[],
                showoverlay : true,
                cu:window.location.href,
                ce : true,
                transactions:[],
                loan:[],
                loan_breakdown:[],
                employee_info:[],
                pay_runs:[],
                pay_slips:[],
                loan_title:'',
                company_title:'',
                total_loan_title:'',
                pageUrl : this.$api_url,
                pgeUrl : this.$api_url,
                avatarsrc : null,
                ewtabIndex : 0,
                public_info : [{name:'', email:'', jobposition:'', department:'', company:'', join_date:'', contract_expire:''}],
                loan_stat_title: ["Declined","Applied","Approved","Pause/Stopped","Retured"],
                tx_type : ["Manual Payment","Debit","Credit"],
                successmsg : false,
                warningmsg : false,
                dangermsg : false,
                action_loader:'',
                modal_title:'',
                count:0,
                loan_status:0,
                is_custom:0,
                is_status:0,
                flg:0,
                loading :'',
                showoverlaymodal_loan_breakdown:true,
                
                c_flg: 0, // This variable is for reloading public info
            }
        },
        methods:{
            
        
            showContent: function()
            {
                this.showoverlay = false;
            },
            replacePayrun:function(data)
            {
                return data.replace('Salary Slip','PF Slip');
            },
            updateTransactions()
            {
                if(!this.checkNet()) return false;
                let currentObj = this; 
                
                // axios.get(this.$api_url+'/pf/loan/updatetransactions', { // Start: Rejwan: 09-02-2026 Front Routes
                axios.get(this.$api_url_front+'/pf/loan/updatetransactions', { // Start: Rejwan: 09-02-2026 Front Routes
                    params: {
                        loan_type: 1
                    }
                }).then(function(response){
                    this.$bvModal.hide('bv-modal-loan');
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
                
            },
            getAcl: function()
            {
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;   
                    if(this.ce == false) this.ewtabIndex = 0;

                }.bind(this));
            }, 
            
			// formatMoney: function(amount)
            // {
            //     var money = Number(amount);
			// 	var dec_points = 0;

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else
			// 		{
			// 			if(money.indexOf(".") < 0)
			// 			{
			// 				money = money+".00";
			// 			}
			// 			else
			// 			{
			// 				dec_points = money.length - money.indexOf('.') - 1;

			// 				if(dec_points == 1)
			// 				{
			// 					money = money+"0";
			// 				}
			// 				else if(dec_points == 0)
			// 				{
			// 					money = money+"00";
			// 				}
			// 			}

            //     	}
			// 	}
                
            //     return money;
            // },   
            toMoney: function(amount){
                if(amount !="0")
                {
                    if(!isNaN(amount))
                    {
                        var number = Number(amount);
                        return number;
                    }
                var NumWithoutCommas = amount.replace(/,/g, ''); 
                var number = Number(NumWithoutCommas).toFixed(2);
                return number;
                }else
                    return amount;
            },
            getLoanTransactionData: function(loan_id,employee_id)
            {
            
                if(!this.checkNet()) return false;
                let currentObj = this;
                let formData = new FormData();
                formData.append('loan_id', loan_id); 
                // formData.append('employee_id', employee_id); // Start: Rejwan: 22-02-2026 Front Routes

                // Start: Rejwan: 22-02-2026 Front Routes
                let url = '';
                if(this.is_self==1) 
                    url = this.$api_url_front+'/self/pf/loan/transactionslist';
                else 
                    url = this.$api_url_front+'/pf/loan/transactionslist';
                // End: Rejwan: 22-02-2026 Front Routes

                // axios.post(this.$api_url+'/pf/loan/transactionslist' ,formData).then(function(response){ // Start: Rejwan: 09-02-2026 Front Routes
                axios.post(url, formData).then(function(response){ // Start: Rejwan: 22-02-2026 Front Routes
                    //Start: Rejwan: 11-03-2025
                    if(!response.data.error) {
                    	this.transactions = response.data.transactions;
                        this.loan_id = response.data.loan_details.loan_id;
                        this.loan_status = response.data.loan_details.status;
                        this.loan = response.data.loan_details;
                        this.loan_breakdown = response.data.loan_breakdown;
                        this.employee_info = response.data.employee_info;
                        this.pay_runs = response.data.pay_runs;
                        this.pay_slips = response.data.pay_slips;
                        this.c_flg += 1; 
                    } 
                    this.showoverlaymodal_loan_breakdown = false;
                    
                    //this.transactions = response.data.transactions;
                    //this.loan_id = response.data.loan_details.loan_id;
                    //this.loan_status = response.data.loan_details.status;
                    //this.loan = response.data.loan_details;
                    //this.loan_breakdown = response.data.loan_breakdown;
                    //this.employee_info = response.data.employee_info;
                    //this.pay_runs = response.data.pay_runs;
                    //this.pay_slips = response.data.pay_slips;
                    //this.c_flg += 1; 
                    //this.showoverlaymodal_loan_breakdown = false; 
                    
                    //End: Rejwan: 11-03-2025

                }.bind(this)).catch(function (error){currentObj.serverError(error);});


            },
            download_file(fileURL, fileName) { 
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href; 
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }	
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
           },
            downloadPaySlip: function(p_slip,f_year,email_file=false,prnt_file=false)
            {
                    this.action_loader = true; 
                    var send_file = email_file ? 1: 0;
                    // axios.get(this.$api_url+'/payslippdf/'+f_year+'/'+p_slip , { // Start: Rejwan: 09-02-2026 Front Routes
                    axios.get(this.$api_url_front+'/payslippdf/'+f_year+'/'+p_slip , { // Start: Rejwan: 09-02-2026 Front Routes
                            params: {
                                em_file:  0,
                                pf_slip: 1
                            }
                    }).then(function(response){
                    
                    this.action_loader = false;
                    if(response.data.file_name){
                
                    if(response.data.download_name) 
                    this.download_file_name = response.data.download_name;
                    else
                    this.download_file_name = this.payslip_title;
                    
                    
                    if(prnt_file)
                    this.download_file(response.data.file_name,this.download_file_name+'.pdf');
                    else if(email_file){
                    if(response.data.success)
                    this.$bvToast.toast(response.data.success, {
                                        title: 'Success',
                                        variant: 'success',
                                        solid: true
                                    });
                    else if(response.data.error)
                    this.$bvToast.toast(response.data.error, {
                                        title: 'Error!',
                                        variant: 'danger',
                                        solid: true
                                    });
                    }
                    else
                    this.download_file(response.data.file_name,this.download_file_name+'.pdf');
                    }
                    else if(response.data.error){
                    this.$bvToast.toast(response.data.error, {
                                        title: 'Error!',
                                        variant: 'danger',
                                        solid: true
                                    });
                    }else{
                    this.$bvToast.toast('Unexpected server error!', {
                                        title: 'Error!',
                                        variant: 'danger',
                                        solid: true
                                    });
                    }
                    //console.log(response.data.file_name);
                }.bind(this));
            }, 
        },
        created: function(){
            //
            this.getAcl();
            this.getLoanTransactionData(this.loan_id,this.employee_id);
            this.updateTransactions();
            
        }

    }

</script>
<style>
.b-overlay-loan-breakdown .b-overlay {
	height: 100%;
}
</style>
<!-- End: Rejwan: 09-02-2026 Front Routes -->
